import React, {useContext, useState} from 'react';
import styles from "./custom-confirm-signin.module.scss";
import {Button, Form, Spinner} from "react-bootstrap";
import Alert from "../alert/alert";
import passwordIcon from "../../assets/login-password-icon.svg";
import {AUTH_INVALID_CODE} from "../../helpr/constants";
import {changeAuthState, cognitoConfirmSignIn, cognitoSignOut, AuthState} from "../../helpr/authHelper";
import {IdentityContext} from "../../context/identity-context";
import InvalidMfaCodeError from "../../models/errors/invalid-mfa-code-error";

const CustomConfirmSignIn = () => {
  /*
    Initiate mfa form state
   */
  const { initialUser } = useContext(IdentityContext);
  const [page, setPage] = useState(0);
  const [mfaState, setMfaState] = useState({onConfirm:false});
  const [showErr, setShowErr] = useState({
    msg: '',
    type: 'alert-danger-custom',
    isVisible: false ,
    onClose: ()=>setShowErr({
      ...showErr,
      ['isVisible']: false
    })
  });
  /*
    Set sign in form on change of fields
   */
  const onChange = (e) => {
    const value = e.target.value;
    setMfaState({
      ...mfaState,
      [e.target.id]: value
    });
  }

  /*
    Handle sign in event
   */
  const confirmSignIn = async(e) => {
    e.preventDefault();
    setMfaState({
      ...mfaState,
      onLogin: true
    });
    const { otp } = mfaState;

    try {
      /*
        Custom fields validation
       */
      if (!otp) {
        throw new Error(AUTH_INVALID_CODE);
      }

      console.log("Signing in...");
      await cognitoConfirmSignIn(initialUser, otp);

    } catch (error) {
      if (error instanceof InvalidMfaCodeError){
        /*
        Display error message in UI
       */
        setShowErr({
          ...showErr,
          ['isVisible']: true,
          msg: error.message,
          type: 'alert-danger-custom',
        });
      }
      else {
        setPage(1);
      }
    } finally {
      setMfaState({
        ...mfaState,
        onLogin: false
      });
    }
  }

  const backToLogin = async () => {
    await cognitoSignOut();
    setPage(0);
  }

  /*
    JSX Markup for custom sign up form
   */
  return (
    <div className={styles['custom-container']}>
      <div className={styles['form-card']}>
        {page === 0 ? (
          <>
            <Alert options={showErr} />
            <div className={styles['app-title-section']}>
              <span>{process.env.REACT_APP_TITLE}</span>
            </div>
            <div className={styles['mfa-title-section']}>
              <span>Enter the 6-digit code from your authenticator app (Google Authenticator, Microsoft Authenticator, etc.).</span>
            </div>
            <div className={styles['form-section']}>
              <Form onSubmit={confirmSignIn}>
                <Form.Group className={styles['input-section']} controlId="otp">
                  <i className={styles['icon']}><img src={passwordIcon} alt="code" /></i>
                  <Form.Control
                    className={styles['mfa-input']}
                    type="text"
                    inputMode="numeric"
                    autoComplete="one-time-code"
                    maxLength={6}
                    placeholder="Enter 6-digit code"
                    onChange={onChange}
                  />
                </Form.Group>
                <Button disabled={mfaState.onConfirm} className={styles['proceed-button']} variant="primary" type="submit">
                  {mfaState.onConfirm ? <Spinner size="sm" animation="border" /> : 'SUBMIT'}
                </Button>
              </Form>
              <Button variant="link" className={styles['back-link']} onClick={backToLogin}>
                Back to Login
              </Button>
            </div>
          </>
        ) : (
          <>
            <div className={styles['app-title-section']}>
              <span>{process.env.REACT_APP_TITLE}</span>
            </div>
            <div className={styles['mfa-title-section']}>
              <span>You have entered an incorrect code too many times. Please go back and try logging in again.</span>
            </div>
            <div className={styles['form-section']}>
              <Button className={styles['back-button']} variant="primary" onClick={() => backToLogin()}>
                BACK TO LOGIN
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default CustomConfirmSignIn;
